<template>
  <LoginGuard>
    <div class="container">
      <b-button-group class="d-none d-sm-block d-md-none d-block d-sm-none">
        <b-button @click="onClick('/login/account')">Profile</b-button>
        <b-button @click="onClick('/logout')">Log Out</b-button>
      </b-button-group>

      <o-section-dashboard-menu :items="items">
        <template v-slot:before-tabs>
          <b-tab title="News Feed">
            <feed></feed>
          </b-tab>
        </template>
      </o-section-dashboard-menu>
    </div>
  </LoginGuard>
</template>

<script>
import LoginGuard from "../vue-ocom/auth/components/LoginGuard";
import MENU_ITEMS from "./menu_items";
// import ONavDashboardMenu from "@/vue-ocom/components/layout/app/ONavDashboardMenu";
import OSectionDashboardMenu from "@/vue-ocom/components/layout/app/OSectionDashboardMenu";
import { CreateCodeTableFetchMixin } from "@/vue-ocom/mixins";
import Feed from "../news/feed/Feed";
import { mapGetters } from "vuex";
import { filterMenuByPrefs } from "@/app/menu_utils";
import {
  filter_active_list,
  sort_and_filter_active_list,
} from "@/vue-ocom/utils/active";
import { HasGroupMixin } from "@/vue-ocom/auth/mixin/AuthFormMixins.js";

export default {
  mixins: [
    CreateCodeTableFetchMixin(["FormTemplate"]),
    HasGroupMixin("Forms Editor"),
  ],
  components: {
    LoginGuard,
    // ONavDashboardMenu,
    OSectionDashboardMenu,
    Feed,
  },
  data: () => ({
    // items: MENU_ITEMS,
  }),
  methods: {
    onClick(url) {
      if (url.startsWith("http")) {
        window.location.href = url;
      } else {
        this.$router.push(url);
      }
    },
    OnBeforeGetFormTemplateCodeList(list_options) {
      list_options.filter = "for_permissions";
    },
  },
  computed: {
    ...mapGetters("AuthModule", ["currentUser"]),
    ...mapGetters({
      global_preferences: "PreferencesModule/global_preferences",
    }),
    items() {
      var menu_items = [...MENU_ITEMS];
      var main_menu = menu_items.find((item) => item.name === "Main Menu");
      var main_menu_index = menu_items.findIndex(
        (item) => item.name === "Main Menu"
      );

      var form_index = menu_items.findIndex(
        (item) => item.name === "Forms"
      );
      if (!this.UserIsForms_Editor) {
        // Remove forms for Non "Forms Editors"
        menu_items.splice(form_index, 1);
      }

      // Get all active form templates
      var active_form_templates = sort_and_filter_active_list(
        this.optionFormTemplateItems,
        null,
        false,
        "name",
        "",
        false,
        "name"
      );
      var children = [
        {
          icon: "view-list",
          title: "List Waiting Requests",
          to: {
            name: "form_entry_workflow_state.list",
            query: {
              limit: 20,
              filter: "assigned",
              sort: "created_date",
              order: "desc",
            },
          },
          loggedIn: true,
        },
      ];

      active_form_templates.forEach((template) => {
        children.push({
          icon: "pencil",
          title: template.name,
          to: {
            name: "form_entry.create",
            query: { form_template_id: template.id },
          },
          loggedIn: true,
        });
      });

      var submit_request = {
        name: "Submit Request",
        children: children,
        loggedIn: true,
      };

      if (main_menu_index !== -1) {
        let submitIndex = main_menu["children"].findIndex(
          (item) => item.name === "Submit Request"
        );
        if (submitIndex < 0) {
          main_menu["children"].push(submit_request);
          menu_items[main_menu_index] = main_menu;
        } else {
          main_menu["children"][submitIndex].children = submit_request.children;
        }
      }

      return filterMenuByPrefs(menu_items, this.global_preferences);
    },
  },
};
</script>
